import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { Tab } from './models/tabs.model';

@Component({
  selector: 'ui-platform-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class UiPlatformTabsComponent {
  @Input() tabs: Tab[] = [];
  @Input() selectedTabIndex = 0;
}
